import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Button } from 'primeng/button';
import { NgIf } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { Directory } from '../../../../../core/interfaces/directory.interface';

@Component({
    selector: 'app-directory-dialog',
    templateUrl: './directory-dialog.component.html',
    imports: [
        Dialog,
        ReactiveFormsModule,
        ConfirmDialogModule,
        Button,
        NgIf,
        InputTextModule,
        FormsModule
    ],
    standalone: true
})
export class DirectoryDialogComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Input() directoryForm!: FormGroup;
    @Input() isEditMode = false;
    @Input() isLoading = false;

    @Output() save = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<void>();

    directoryValidation(): boolean {
        let fields = ['name'];
        if (this.isEditMode) fields.pop();
        return this.isValid(fields);
    }

    private isValid(fields: string[]): boolean {
        return fields.every(field => this.directoryForm.get(field)?.valid);
    }

    get id() {
        return this.directoryForm.get('id')!;
    }

    get name() {
        return this.directoryForm.get('name')!;
    }
}
